export function isBijlesnetwerk() {
    return $('body').hasClass('site-bijlesnetwerk');
}

export default {isBijlesnetwerk};
